import { HostedPaymentsPaymentDetailsFormSubmitEvent } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsPaymentDetailsComponentActions = createActionGroup({
  source: 'Hosted Payments Payment Details Component',
  events: {
    'Payment Details Step Submitted': props<{
      payload: HostedPaymentsPaymentDetailsFormSubmitEvent;
    }>(),
    'Account Number Changed': props<{
      accountNumber: string;
    }>(),
  },
});
